import { Modal } from 'rsuite';
import styled from 'styled-components';

export const Title = styled(Modal.Title)`
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
`;
export const Iframe = styled.iframe`
  width: 100%;
  height: calc(100vh - 150px);
  max-height: 1000px; /* figure out document dimensions from Digify */
`;
export const LoaderWrapper = styled.div`
  display: flex;
  height: 200px;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`;
